// import Vue from 'vue'
import {
	RUN_USER_LOGIN, RUN_USER_SIGNUP, RUN_VERIFY_LEAD_OTP, RUN_USER_LOGOUT, SET_TOGGLE_LOADER, SET_INFO, SET_STATE, SET_STATE_PERSIST_LOCAL,RUN_DELETE_DOC,
	RUN_SAVE_USER_NAME, RUN_REGISTER_STEP1, RUN_REGISTER_STEP2, RUN_REGISTER_STEP3, RUN_REGISTER_STEP_TMA, SET_RISK_WARNING_POPUP, RUN_REGISTER_STEP4, RUN_REGISTER_STEP5, RUN_SKIP_DOCUMENT_UPLOAD, GET_TOKEN,
	RUN_GET_QUESTION_ANSWER,RUN_GET_QUESTION_ANSWER_TMA, RUN_TMA_USER_RESPONSE, RUN_STATE_LOAD, RUN_USER_FORGOT_PASSWORD, RUN_GET_USER_IP, RUN_GENERATE_2FA_QRCODE, RUN_VERIFY_2FA_QRCODE, RUN_DISABLE_2FA_QRCODE, RUN_USER_RESET_PASSWORD_FROM_HASH, RUN_CHANGE_PASSWORD, RUN_GET_SUM_SUB_RESPONSE, RUN_RESOLVE_DOC_ISSUE, RUN_USER_LOGIN_2FA, SAVE_FIREBASE_TOKEN
} from '../types'
import * as RxFactory from './api/rx-factory'
import * as Enpoints from './api/endpoints'
import * as types from '@/types'
import { Const } from '../plugins/fxView/provider/candle-history/lib/const.cls'


export const actions = {
	//================================get country code===============================
	[RUN_GET_USER_IP]({ commit, state, getters }, credentials) {
		RxFactory.get("https://api.ipify.org/?format=json")
			.map(response => response.data)
			.subscribe(data => {
				/*RxFactory.get("https://ipapi.co/" + data.ip + "/json/")*/
				RxFactory.get("https://expapi.fxview.com/get/geo")
					.map(response => response.data)
					.subscribe(data => {
						// credentials.localParams.parameter.userCountry = data.country_code
						credentials.localParams.parameter.userCountry = data
					},
						(e, d, s) => { }
					)
			},
				(e, d, s) => { }
			)
	},
	//================================2FA===========================================
	[RUN_GENERATE_2FA_QRCODE]({ commit, state, getters }, credentials) {
		_executeApi(Enpoints.EP_GENERATE_2FA_QRCODE, credentials.globalParams, credentials.localParams, '', commit, (error, result) => {
			if (!error) {
				credentials.localParams.parameter.src_data = result.res_data
			} else {
				if (credentials.localParams.parameter.call_from != '' || credentials.localParams.parameter.call_from != null) {
					credentials.localParams.parameter.$parent.authComponent = true
				}
				_messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
			}
		})
	},
	[RUN_VERIFY_2FA_QRCODE]({ commit, state, getters }, credentials) {
		_executeApi(Enpoints.EP_VERIFY_2FA_QRCODE, credentials.globalParams, credentials.localParams, '', commit, (error, result) => {
			if (!error) {
				let user_json = getters['GET_USER']
				user_json.profile.gAuthenticatorEnabled = 1
				commit(SET_STATE, user_json)
				localStorage.setItem('unauthFlag', '')
				var user = localStorage.getItem('user')
				user = atob(user); user = JSON.parse(user)
				user.profile.gAuthenticatorEnabled = 1
				localStorage.setItem('user', btoa(JSON.stringify(user)))
				credentials.localParams.parameter.div_show = ''
				if (credentials.localParams.parameter.call_from != '' || credentials.localParams.parameter.call_from != null) {
					credentials.localParams.parameter.$parent.authComponent = false

				} else {
					credentials.localParams.parameter.otp = ''
					credentials.localParams.parameter.div_show = ''
				}
				_messageDisplayFunction(credentials.localParams.parameter, 'suceessMsz1', 'success')
			} else {
				//credentials.localParams.parameter.div_show = ''
				if (credentials.localParams.parameter.call_from != '' || credentials.localParams.parameter.call_from != null) {
					credentials.localParams.parameter.$parent.authComponent = true
				}
				_messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')

			}
		})
	},
	[RUN_DISABLE_2FA_QRCODE]({ commit, state, getters }, credentials) {
		_executeApi(Enpoints.EP_DISABLE_2FA_QRCODE, credentials.globalParams, credentials.localParams, '', commit, (error, result) => {
			if (!error) {
				credentials.localParams.parameter.DisableOtp = ''
				credentials.localParams.parameter.div_show = ''
				credentials.localParams.parameter.generateQrCode()
				let user_json = getters['GET_USER']
				user_json.profile.gAuthenticatorEnabled = 0
				commit(SET_STATE, user_json)


				var user = localStorage.getItem('user')
				user = atob(user); user = JSON.parse(user)
				user.profile.gAuthenticatorEnabled = 0
				localStorage.setItem('user', btoa(JSON.stringify(user)))
				_messageDisplayFunction(credentials.localParams.parameter, 'suceessMsz2', 'success')
			} else {
				_messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
			}
		})
	},
	[SAVE_FIREBASE_TOKEN]({ commit, state, getters }, credentials) {
		_executeApi(Enpoints.EP_SAVE_FIREBASE_TOKEN, credentials.globalParams, credentials.localParams, '', commit, (error, result) => {
			if (!error) {
				console.log('firebase_token--', result.res_data)
			} else {
				_messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
			}
		})
	},
	//================================login==========================================
	[RUN_USER_LOGIN]({ commit, state, dispatch, getters }, credentials) {
		_executeApi(Enpoints.EP_USER_LOGIN, credentials.globalParams, credentials.localParams, '', commit, (error, result) => {
			if (!error) {
				localStorage.setItem('unauthFlag', '')

				if (parseInt(result.res_data.user.profile.gAuthenticatorEnabled) == 1) {
					credentials.localParams.parameter.gAuthenticatorEnabled = true
				} else {
					result.res_data.user.loggedIn = true
					commit(SET_STATE, result.res_data.user)
					localStorage.setItem('user', btoa(JSON.stringify(result.res_data.user)))
					if (parseInt(result.res_data.user.step) <= 4) {
						credentials.localParams.parameter.$router.replace('/index')
					} else {
						credentials.localParams.parameter.$router.replace('/dashboard')
					}
				}
				try {
					/*window.dataLayer.push({ 'event': 'login', 'loginMethod': 'email' });*/
					window.gtag('config', 'G-STJT5YW0S4', { 'user_id': "EU_"+result.res_data.user.profile.user_id  });
				} catch (ex) {
					console.log('ex', ex)
				}
			} else {
				//_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
				_messageDisplayFunction(credentials.localParams.parameter, result.res_msg, 'error')
				/*try {
					window.dataLayer.push({ 'event' : 'error', 'errorType' : 'login error', 'errorMessage' : result.res_msg });
				} catch (ex) {
					console.log('ex', ex)
				}*/
			}
		})
	},

	[RUN_USER_LOGIN_2FA]({ commit, state, dispatch, getters }, credentials) {
		_executeApi(Enpoints.EP_USER_LOGIN_2FA, credentials.globalParams, credentials.localParams, '', commit, (error, result) => {
			if (!error) {
				try {
					window.dataLayer.push({
					  'event': 'login',
					  'loginMethod': 'email'
					});

					window.gtag('config', 'G-STJT5YW0S4', { 'user_id': "EU_"+result.res_data.user.profile.user_id });
				} catch (ex) {
					console.log('ex', ex)
				}
				localStorage.setItem('unauthFlag', '')
				result.res_data.user.loggedIn = true
				commit(SET_STATE, result.res_data.user)
				localStorage.setItem('user', btoa(JSON.stringify(result.res_data.user)))
				if (parseInt(result.res_data.user.step) <= 4) {
					credentials.localParams.parameter.$router.replace('/index')
				} else {
					credentials.localParams.parameter.$router.replace('/dashboard')
				}
			} else {
				//_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
				_messageDisplayFunction(credentials.localParams.parameter, result.res_msg, 'error')
				/*try {
					window.dataLayer.push({ 'event' : 'error', 'errorType' : 'login error', 'errorMessage' : result.res_msg });
				} catch (ex) {
					console.log('ex', ex)
				}*/
			}
		})
	},
	//===========================Reset-password-from-hash=====================================
	[RUN_USER_RESET_PASSWORD_FROM_HASH]({ commit, state, dispatch, getters }, credentials) {
		_executeApi(Enpoints.EP_RESET_PASSWORD_FROM_HASH, credentials.globalParams, credentials.localParams, '', commit, (error, result) => {
			if (!error) {
				const _that = credentials.localParams.parameter

				_that.displayMessage = 1
				_that.displayMessageText = "Password has been changed successfully. Kindly click here tp login"
				// _messageDisplayFunction(credentials.localParams.parameter,'','success')
			} else {
				_messageDisplayFunction(credentials.localParams.parameter, 'errorMsz1', 'error')
			}
		})
	},
	//===========================forgot-password=====================================
	[RUN_USER_FORGOT_PASSWORD]({ commit, state, dispatch, getters }, credentials) {
		_executeApi(Enpoints.EP_USER_FORGOT_PASSWORD, credentials.globalParams, credentials.localParams, '', commit, (error, result) => {
			if (!error) {
				credentials.localParams.parameter.resend = true
				_messageDisplayFunction(credentials.localParams.parameter, 'suceessMsz3', 'success')
			} else {
				_messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
			}
		})
	},


	[RUN_CHANGE_PASSWORD]({ commit, state, getters }, credentials) {
		_executeApi(Enpoints.EP_CHANGE_PASSWORD, credentials.globalParams, credentials.localParams, { 'Authorization': 'Bearer ' + getters[GET_TOKEN] }, commit, (error, result) => {
			if (!error) {
				credentials.localParams.parameter.clear()
				_messageDisplayFunction(credentials.localParams.parameter, 'suceessMsz4', 'success')
			} else {
				_messageDisplayFunction(credentials.localParams.parameter, result.res_msg, 'error')
			}
		})

	},
	//================================signup=========================================
	[RUN_USER_SIGNUP]({ commit, state, dispatch, getters }, credentials) {
		_executeApi(Enpoints.EP_USER_SIGNUP, credentials.globalParams, credentials.localParams, '', commit, (error, result) => {
			if (!error) {
				if (credentials.localParams.page) {
					credentials.localParams.parameter.insertId = result.res_data.insertId
					_messageDisplayFunction(credentials.localParams.parameter, 'OTP resend successfully', 'success')

					
					//_messageDisplayFunction(credentials.localParams.parameter,'suceessMsz5','success')
				} else {
					try {
						window.gtag('event', 'generate_lead', {'event_name': 'generate_lead'/*, 'send_to': 'G-1E20EEPN1W'*/});
						window.fbq('trackCustom', 'generate_lead', {  'value': '0', 'country':  credentials.globalParams.residence_country, 'Currency': 'USD'}, { 'eventID': credentials.globalParams.email });
					} catch (ex) {
						console.log('ex', ex)
					}
					credentials.localParams.parameter.insertId = result.res_data.insertId
					//_messageDisplayFunction(credentials.localParams.parameter,'OTP is sent on your register email and mobile number','success')
					//_messageDisplayFunction(credentials.localParams.parameter,'suceessMsz6','success')
				}

			} else {
				//_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
				_messageDisplayFunction(credentials.localParams.parameter, result.res_msg, 'error')
				/*try {
					window.dataLayer.push({
					  	'event' : 'error',
						'errorType' : 'registration error',
						'errorMessage' : result.res_msg
					});
				} catch (ex) {
					console.log('ex', ex)
				}*/
			}
		})
	},
	[RUN_VERIFY_LEAD_OTP]({ commit, state, dispatch, getters }, credentials) {
		_executeApi(Enpoints.EP_VERIFY_LEAD_OTP, credentials.globalParams, credentials.localParams, '', commit, (error, result) => {
			if (!error) {
				 credentials.localParams.parameter.otpSubmitEvent()
				_messageDisplayFunction(credentials.localParams.parameter, 'SignUp successfully', 'success')
				result.res_data.user.loggedIn = true
				commit(SET_STATE, result.res_data.user)
				try {
					window.gtag('event', 'OTP_verified', {'event_name': 'OTP_verified', 'user_id': "EU_"+result.res_data.user.profile.user_id/*, 'send_to': 'G-1E20EEPN1W'*/ });
					window.fbq('trackCustom', 'OTP_verified', { 'OTP':credentials.globalParams.OTP, 'value': '20', 'country': result.res_data.user.profile.country, 'Currency': 'USD'  }, { 'eventID': credentials.globalParams.OTP + '-' + result.res_data.user.profile.user_id });

					let p_countries = {'AE':104607,'AR':104608,'AU':103314,'BR':104609,'CA':104610,'DE':103065,'DK':103066,'ES':103313,'IT':104611,'KE':104612,'MA':104613,'NG':104614,'NL':103061,'PE':104615,'PL':104616,'PT':103312,'SA':104617,'SE':103309,'ZA':104618};
			        /*fetch('https://ipapi.co/country?key=WqrqGPQYxfU6ySEZKqlU8bNDk9BgWVez4Uk3L4auzRyosaOWSs').then(res => {
			            if (res.ok) { return res.text(); }
			            else { throw new Error('HTTP Error ' + res.status); }
			        })
			        .then(country => {*/
			        let country = localStorage.getItem("ip_country") || '';
			          if(p_countries[country]){
			            var deviceType = /iPad/.test(navigator.userAgent) ? "t" : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(navigator.userAgent) ? "m" : "d";
			            var crypto = require('crypto');
			            try{
			              	/*let email = crypto.createHash('md5').update(this.get_user.email).digest("hex");*/
			              	let email = crypto.createHash('md5').update('1').digest("hex");

							let setAccount ={ event: "setAccount", account: p_countries[country] };
							let setEmail ={ event: "setEmail", email: email, hash_method: "md5" };
							let setSiteType ={ event: "setSiteType", type: deviceType};
							let trackTransaction ={ event: "trackTransaction", id: result.res_data.user.profile.user_id, item: [
								{id: "registration", price: "1", quantity: "1" }
							]}
			              	/*console.log('critio-update-Conversion-before :- ',JSON.stringify([setAccount,setEmail,setSiteType,trackTransaction]))*/
			              	window.criteo_q.push(setAccount,setEmail,setSiteType,trackTransaction);
			              	/*console.log('critio-update-Conversion-after :- ',JSON.stringify([setAccount,setEmail,setSiteType,trackTransaction]))*/
			            }catch(e){ console.log(e); }
			          }
			        /*}).catch(function(error) { console.log(error);  });*/

				} catch (e) { }

				localStorage.setItem('user', btoa(JSON.stringify(result.res_data.user)))
				credentials.localParams.parameter.flashSuccess('login successfully', { timeout: 10000 })
				credentials.localParams.parameter.$router.replace('/index')
			} else {
				//_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
				if (result.res_msg == "OTP verification error") {
					let msg = "Incorrect OTP entered. Please check your email for the correct OTP"
					_messageDisplayFunction(credentials.localParams.parameter, msg, 'error')
				} else {
					_messageDisplayFunction(credentials.localParams.parameter, result.res_msg, 'error')
				}
			}
		})
	},
	[RUN_STATE_LOAD]({ commit, dispatch, state, getters }, credentials = {'localParams':{}}) {
		const data = {}
		let user = localStorage.getItem('user')
		if (user) {
			user = atob(user)
			user = JSON.parse(user)
		}
		//this.$root.functionCall()
		// https://dev.finvasia.com:8083/forgot/password/%242a%2410%24cD1wqfVFu8qaoSK5J1SFs.KObxyTmWKEwpPqyIqA%2FDNfbi0fJ0xei
		if (user == null || user == '' || location.pathname == '/') {
			localStorage.setItem('unauthFlag', '')
		}
		if ((user == null || user == '' || location.pathname !== '/forgot/password/' || location.pathname !== '/forgot-password') && location.pathname == '/Users/dashboard') {
			localStorage.setItem('unauthFlag', true)
		}
		else {
			commit(SET_STATE, user)
		}
		if ((user !== null && user !== '') || "auth" in credentials.localParams || credentials.localParams.auth) {

			localStorage.setItem('unauthFlag', '')

			// console.log("credentials.localParams.auth", credentials.localParams)

			RxFactory.post(Enpoints.BASE_URL + "/get/fresh/user/data", {}, { 'Authorization': 'Bearer ' + (credentials.localParams.auth ? credentials.localParams.auth : getters[GET_TOKEN]) })
				.map(response => response.data)
				.subscribe(data => {
					if ('info' in data) {
						if (data.info === 'OK') {
							data.data.user.loggedIn = true
							commit(SET_STATE, data.data.user)

							console.log(" data.data.user",  data.data.user)
							localStorage.setItem('user', btoa(JSON.stringify(data.data.user)))
							// localStorage.setItem('user', JSON.stringify(data.data.user))
							try{
								let temp_query = localStorage.getItem('temp_query')
								let lastPath = localStorage.getItem('lastPath')
								if (temp_query) {
									temp_query = JSON.parse(temp_query)
									delete temp_query.auth
									localStorage.removeItem("temp_query")
									credentials.localParams.parameter.$router.replace({'path':lastPath,'query':temp_query})
								}else if (credentials.localParams.path) {
									credentials.localParams.parameter.$router.replace(credentials.localParams.path)
								}
							}catch(e){ console.log(e); }
						}
					}
				},
					e => {
						_handleErrorResponse(e, commit)
					}
				)
		}
	},

	//================================logout=========================================
	[RUN_USER_LOGOUT]({ commit, state, getters }, credentials) {
		RxFactory.get(Enpoints.BASE_URL + Enpoints.EP_ADMIN_LOGOUT, credentials.globalParams, { 'Authorization': 'Bearer ' + getters[GET_TOKEN] })
			.map(response => response.data)
			.subscribe(data => {
				_handleLogout(data, commit, { router: credentials.localParams.parameter.$router, forward: true })
			},
				(e, d, s) => {
					_handleLogout(e, commit, { router: credentials.localParams.parameter.$router, forward: true })
				}
			)
	},
	//================================register steps=================================
	[RUN_SAVE_USER_NAME]({ commit, state, dispatch, getters }, credentials) {
		_executeApi(Enpoints.EP_SAVE_USER_NAME, credentials.globalParams, credentials.localParams, { 'Authorization': 'Bearer ' + getters[GET_TOKEN] }, commit, (error, result) => {
			if (!error) {
				let user_json = getters['GET_USER']
				user_json.username = credentials.globalParams.fname + ' ' + credentials.globalParams.mname + ' ' + credentials.globalParams.lname
				user_json.profile.firstname = credentials.globalParams.fname
				user_json.profile.middlename = credentials.globalParams.mname
				user_json.profile.lastname = credentials.globalParams.lname
				user_json.mobile_no = credentials.globalParams.mobile_no
				commit(SET_STATE, user_json)

				var user = localStorage.getItem('user')
				user = atob(user)
				user = JSON.parse(user)
				user.username = credentials.globalParams.fname + ' ' + credentials.globalParams.mname + ' ' + credentials.globalParams.lname
				user.profile.firstname = credentials.globalParams.fname
				user.profile.middlename = credentials.globalParams.mname
				user.profile.lastname = credentials.globalParams.lname
				user.mobile_no = credentials.globalParams.mobile_no
				localStorage.setItem('user', btoa(JSON.stringify(user)))

				credentials.localParams.parameter.mobileShowvar = false
				//_messageDisplayFunction(credentials.localParams.parameter,'suceessMsz9','success')
			} else {
				_messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
			}
		})
	},
	[RUN_REGISTER_STEP1]({ commit, state, dispatch, getters }, credentials) {
		_executeApi(Enpoints.EP_REGISTER_STEP1, credentials.globalParams, credentials.localParams, { 'Authorization': 'Bearer ' + getters[GET_TOKEN] }, commit, (error, result) => {
			if (!error) {
				//credentials.localParams.parameter.$parent.$parent.showStepComponent = true
				let user_json = getters['GET_USER']
				user_json.step = 1
				user_json.username = credentials.globalParams.fname + ' ' + credentials.globalParams.mname + ' ' + credentials.globalParams.lname
				user_json.profile.firstname = credentials.globalParams.fname
				user_json.profile.middlename = credentials.globalParams.mname
				user_json.profile.lastname = credentials.globalParams.lname
				commit(SET_STATE, user_json)

				var user = localStorage.getItem('user')
				user = atob(user); 
				user = JSON.parse(user)
				user.step = 1
				localStorage.setItem('user', btoa(JSON.stringify(user)))
			} else {
				_messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
			}
		})
	},

	[RUN_REGISTER_STEP2]({ commit, state, dispatch, getters }, credentials) {
		_executeApi(Enpoints.EP_REGISTER_STEP2, credentials.globalParams, credentials.localParams, { 'Authorization': 'Bearer ' + getters[GET_TOKEN] }, commit, (error, result) => {
			if (!error) {
				let user_json = getters['GET_USER']
				user_json.step = 2
				commit(SET_STATE, user_json)
				var user = localStorage.getItem('user')
				user = atob(user); user = JSON.parse(user)
				user.step = 2
				localStorage.setItem('user', btoa(JSON.stringify(user)))
			} else {
				_messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
			}
		})
	},
	[RUN_REGISTER_STEP3]({ commit, state, dispatch, getters }, credentials) {
		_executeApi(Enpoints.EP_REGISTER_STEP3, credentials.globalParams, credentials.localParams, { 'Authorization': 'Bearer ' + getters[GET_TOKEN] }, commit, (error, result) => {
			if (!error) {
				let user_json = getters['GET_USER']
				user_json.profile.total_points = result.res_data.total_points
				var user = localStorage.getItem('user')
				user = atob(user); user = JSON.parse(user)
				credentials.localParams.parameter.showRisk = true
				user_json.step = 4;
				user.step = 4;
				commit(SET_STATE, user_json)
				localStorage.setItem('user', btoa(JSON.stringify(user)))
			} else {
				_messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
			}
		})
	},
	[RUN_GET_QUESTION_ANSWER_TMA]({ commit, state, dispatch, getters }, credentials) {
		_executeApi(Enpoints.EP_GET_QUESTION_ANSWER_TMA, credentials.globalParams, credentials.localParams, { 'Authorization': 'Bearer ' + getters[GET_TOKEN] }, commit, (error, result) => {
			if (!error) {
				const questiondata = result.res_data
				for(const key in questiondata){
					let data = questiondata[key];
					credentials.localParams.parameter.answer_list[data.sequence] = data
					credentials.localParams.parameter.answer_Selected[key] = ''
					credentials.localParams.parameter.test_step = 1
				}
				credentials.localParams.parameter.getStep()

			} else {
				_messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
			}
		})
	},
	[RUN_REGISTER_STEP_TMA]({ commit, state, dispatch, getters }, credentials) {
		_executeApi(Enpoints.EP_REGISTER_STEP_TMA, credentials.globalParams, credentials.localParams, { 'Authorization': 'Bearer ' + getters[GET_TOKEN] }, commit, (error, result) => {
			if (!error) {
				let user_json = getters['GET_USER']
				var user = localStorage.getItem('user')
				user = atob(user); user = JSON.parse(user)
				credentials.localParams.parameter.test_step = 2
				credentials.localParams.parameter.showTmaContinue = true
				credentials.localParams.parameter.tmaResult = result.res_data
				credentials.localParams.parameter.tmaEnabled = true
				commit(SET_STATE, user_json)
				localStorage.setItem('user', btoa(JSON.stringify(user)))
				
			} else {
				_messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
			}
		})
	},
	[RUN_TMA_USER_RESPONSE]({ commit, state, dispatch, getters }, credentials) {
		_executeApi(Enpoints.EP_TMA_USER_RESPONSE, credentials.globalParams, credentials.localParams, { 'Authorization': 'Bearer ' + getters[GET_TOKEN] }, commit, (error, result) => {
			if (!error) {
				let user_json = getters['GET_USER']
				var user = localStorage.getItem('user')
				// console.log(user)
				// console.log(typeof user)
				user = atob(user); user = JSON.parse(user)
				credentials.localParams.parameter.tmaResult = result.res_data[0].tma_result
				credentials.localParams.parameter.tmaEnabled = true
				credentials.localParams.parameter.showTmaContinue = !result.res_data[0].tma_result ? false : true
				commit(SET_STATE, user_json)
				localStorage.setItem('user', btoa(JSON.stringify(user)))
				
			} else {
				_messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
			}
		})
	},

	[SET_RISK_WARNING_POPUP]({ commit, state, dispatch, getters }, credentials) {
		_executeApi(Enpoints.EP_RISK_WARNING_POPUP, credentials.globalParams, credentials.localParams, { 'Authorization': 'Bearer ' + getters[GET_TOKEN] }, commit, (error, result) => {
			if (!error) {
				let user_json = getters['GET_USER'];
				if(parseInt(credentials.globalParams.risk_warning) == 1){
					credentials.localParams.parameter.$parent.showRisk = false
					user_json.step = 4
					user_json.profile.risk_warning = 1
					var user = localStorage.getItem('user')
					user = atob(user); 
					user = JSON.parse(user)
					user.profile.risk_warning = 1
					localStorage.setItem('user', btoa(JSON.stringify(user)))
					
				}else if(parseInt(credentials.globalParams.risk_warning) == 2){
					credentials.localParams.parameter.$parent.showRisk = false
					credentials.localParams.parameter.$parent.testFail = true
					user_json.profile.risk_warning = 2
					var user = localStorage.getItem('user')
					user = atob(user); 
					user = JSON.parse(user)
					user.profile.risk_warning = 2
					localStorage.setItem('user', btoa(JSON.stringify(user)))
				}
				commit(SET_STATE, user_json)
			} else {
				_messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
			}
		})
	},
	[RUN_REGISTER_STEP4]({ commit, state, dispatch, getters }, credentials) {
		_executeApi(Enpoints.EP_REGISTER_STEP4, credentials.globalParams, credentials.localParams, { 'Authorization': 'Bearer ' + getters[GET_TOKEN] }, commit, (error, result) => {
			if (!error) {
				let user_json = getters['GET_USER']
				user_json.step = 5
				commit(SET_STATE, user_json)

				var user = localStorage.getItem('user')
				user = atob(user); 
				user = JSON.parse(user)
				user.step = 5
				localStorage.setItem('user', btoa(JSON.stringify(user)))
				try {
					window.dataLayer.push({
						'event': 'registration',
						'successType': 'registration success step 4'
					});
				} catch (ex) {
					console.log('ex', ex)
				}
			} else {
				_messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
			}
		})
	},
	[RUN_REGISTER_STEP5]({ commit, state, dispatch, getters }, credentials) {
		_executeApi(Enpoints.EP_REGISTER_STEP5, credentials.globalParams, credentials.localParams, { 'Authorization': 'Bearer ' + getters[GET_TOKEN] }, commit, (error, result) => {
			if (!error) {
				if (credentials.localParams.fromStep == 5.1) {
					if (credentials.localParams.step != undefined) {
						let user_json = getters['GET_USER']
						user_json.step = 5
						commit(SET_STATE, user_json)

						try {
							var user = localStorage.getItem('user'); // Retrieve the data
							user = atob(user);
							user = JSON.parse(user); 
							localStorage.setItem('user', btoa(JSON.stringify(user)))
						} catch (error) {
							console.error("Error processing user data from localStorage:", error);
						}

						credentials.localParams.parameter.$parent.ticket_id = result.res_data[0].insertId
						credentials.localParams.parameter.clientKycEvent()
						localStorage.setItem('ticketId', result.res_data[0].insertId)
						// credentials.localParams.parameter.$router.replace('/dashboard')

						if (!(credentials.localParams.parameter.mobileScreen)) {
							credentials.localParams.parameter.$router.replace({ name: "fxView.view", query: { 'id': result.res_data[0].insertId } })
						}
					} else {
						credentials.localParams.parameter.documentJsonData = {}
						credentials.localParams.parameter.stepInfo()
						credentials.localParams.parameter.clearOld()
						credentials.localParams.parameter.showTab += 1
						credentials.localParams.parameter.fileNameChange()
					}
					/*try {
						window.dataLayer.push({ 'event': 'registration', 'successType': 'registration success step 5' });
					} catch (ex) {
						console.log('ex', ex)
					}*/
				}
				else{
					let user_json = getters['GET_USER']
					user_json.step = 5
					commit(SET_STATE, user_json)

					var user = localStorage.getItem('user')
					user = atob(user); 
					user = JSON.parse(user)
					user.step = 5
					localStorage.setItem('user', btoa(JSON.stringify(user)))
					credentials.localParams.parameter.$router.replace('/create-live-account')

					if (parseInt(result.res_data.risk_status) == 1) {
						credentials.localParams.parameter.iframeVar = ''
						credentials.localParams.parameter.riskDiv = true
					}

					_messageDisplayFunction(credentials.localParams.parameter, 'suceessMsz7', 'success')
					try {
						/*window.dataLayer.push({
							'event': 'registration',
							'successType': 'registration success step 5',
							'successMessage': 'Now eligible to open live account'
						});*/

						window.gtag('event', 'Verified_live_Account', {'event_name': 'Verified_Live_Account', 'user_id': "EU_"+user.profile.user_id/*, 'send_to': 'G-1E20EEPN1W'*/ });
						/*window.fbq('track', 'complete registration', {'external_id': "EU_"+user.profile.user_id});*/

					} catch (ex) {
						console.log('ex', ex)
					}
				}
			} else {
				_messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
				try {
					/*window.dataLayer.push({
					  'event': 'error',
					  'errorType': 'registration error step 5', // or registration error
					  'errorMessage': result.res_data //this should be replaced with an actual error message
					});*/
				} catch (ex) {
					console.log('ex', ex)
				}
			}
		})
	},
	[RUN_SKIP_DOCUMENT_UPLOAD]({ commit, state, dispatch, getters }, credentials) {
		_executeApi(Enpoints.EP_SKIP_DOCUMENT_UPLOAD, credentials.globalParams, credentials.localParams, { 'Authorization': 'Bearer ' + getters[GET_TOKEN] }, commit, (error, result) => {
			if (!error) {
				let user_json = getters['GET_USER']
				user_json.step = 5
				commit(SET_STATE, user_json)

				var user = localStorage.getItem('user')
				user = atob(user) 
				user = JSON.parse(user)
				user.step = 5
				localStorage.setItem('user', btoa(JSON.stringify(user)))
				credentials.localParams.parameter.$router.replace('/create-live-account')

				if (parseInt(result.res_data.risk_status) == 1) {
					credentials.localParams.parameter.iframeVar = ''
					credentials.localParams.parameter.riskDiv = true
				}
				_messageDisplayFunction(credentials.localParams.parameter, 'suceessMsz8', 'success')
			} else {
				_messageDisplayFunction(credentials.localParams.parameter, result.res_msg, 'error')
			}
		})
	},
	[RUN_DELETE_DOC]({ commit, state, dispatch, getters }, credentials) {
		_executeApi(Enpoints.EP_DELETE_DOC, credentials.globalParams, credentials.localParams, { 'Authorization': 'Bearer ' + getters[GET_TOKEN] }, commit, (error, result) => {
			if (!error) {
				if (credentials.localParams.getData != null) {
					credentials.localParams.parameter.documentJsonData = {}
					credentials.localParams.parameter.stepInfo()
				}
			} else {
				_messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
			}
		})
	},
	[RUN_GET_SUM_SUB_RESPONSE]({ commit, state, dispatch, getters }, credentials) {
		_executeApi(Enpoints.EP_GET_SUM_SUB_RESPONSE, credentials.globalParams, credentials.localParams, { 'Authorization': 'Bearer ' + getters[GET_TOKEN] }, commit, (error, result) => {
			if (!error) {
				credentials.localParams.parameter.subSubResp(result.res_data)
			} else {
				_messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
			}
		})
	},
	[RUN_RESOLVE_DOC_ISSUE]({ commit, state, dispatch, getters }, credentials) {
		_executeApi(Enpoints.EP_RESOLVE_DOC_ISSUE, credentials.globalParams, credentials.localParams, { 'Authorization': 'Bearer ' + getters[GET_TOKEN] }, commit, (error, result) => {
			if (!error) {
				if (credentials.globalParams.overallStatus == 1) {
					credentials.localParams.parameter.resolveMismatch = false
					credentials.localParams.parameter.iframeVar = false
					credentials.localParams.parameter.allOkay = true

					let user_json = getters['GET_USER']
					user_json.step = 5
					user_json.verified = 1
					commit(SET_STATE, user_json)

					var user = localStorage.getItem('user')
					user = atob(user); 
					user = JSON.parse(user)
					user.step = 5
					localStorage.setItem('user', btoa(JSON.stringify(user)))
				} else {
					credentials.localParams.parameter.resolveMismatch = false
					credentials.localParams.parameter.iframeVar = false
					credentials.localParams.parameter.inManual = true
				}
				//_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'success')
			} else {
				_messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
			}
		})
	},
	//================================get question-answer============================
	[RUN_GET_QUESTION_ANSWER]({ commit, state, dispatch, getters }, credentials) {
		_executeApi(Enpoints.EP_GET_QUESTION_ANSWER, credentials.globalParams, credentials.localParams, { 'Authorization': 'Bearer ' + getters[GET_TOKEN] }, commit, (error, result) => {
			if (!error) {
				credentials.localParams.parameter.ques_ans_list = result.res_data
				credentials.localParams.parameter.ques_ans_array = Array(result.res_data.length).fill()
				//get sequence
				const questiondata = result.res_data
				for(const key in questiondata){
					let data = questiondata[key]
					credentials.localParams.parameter.question_answer_key_array[data.sequence] = key
					credentials.localParams.parameter.answer_list[data.sequence] = data
					credentials.localParams.parameter.answer_Selected[key] = ''
				}
				const knowledgeArray = Object.entries(result.res_data);
				const knowledgeArrayList = knowledgeArray.filter(([key, item]) => {
					return item.type === 'Knowledge'; // Filter Knowledge values
				});
				// console.log(knowledgeArrayList, "=== Knowledge");

				const tradingArray = Object.entries(result.res_data);
				const tradingArrayList = tradingArray.filter(([key, item]) => {
					return item.type === 'Trading Experience'; // Filter Trading Experience values
				});
				// console.log(tradingArrayList, "=== Trading Experience");

				/*let ques_ans = Object.keys(result.res_data)
				for (var i = ques_ans.length - 1; i >= 0; i--) {
					if (questiondata[ques_ans[i]] && ques_ans[i]) {
						credentials.localParams.parameter.question_answer_key_array[questiondata[ques_ans[i]].sequence] = ques_ans[i]
					}
				}*/
				// credentials.localParams.parameter.question_answer_key_array = Object.keys(result.res_data)
				credentials.localParams.parameter.getStep()

			} else {
				_messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
			}
		})
	},
}

//================================functions======================================
function _cleanUp(commit, msg, status, loaderId) {
	let loaderArr = (typeof loaderId !== 'undefined') ? [loaderId] : []
	commit(SET_TOGGLE_LOADER, loaderArr)
	commit(SET_INFO, msg)
}
function _handleErrorResponse(e, commit) {
	let response = { info: 'NOK', msg: 'Service not available' }
	if (typeof e.response === 'undefined') {
		try {
			const statusCheck = e.toString().toLowerCase()
			if (statusCheck.indexOf('network') > -1) {
				response = { info: 'NOK', msg: 'Network Error' }
			}
		} catch (e) { }
	} else {
		if (e.response.status == '401') {
			localStorage.removeItem('user');
			localStorage.setItem('unauthFlag', true)
			window.dispatchEvent(new Event('storage'));
			let user = {
				active: 0,
				country: '',
				created: '',
				email: '',
				profile: {
					firstname: '',
					lastname: '',
					pid: '',
					cid: ''
				},
				roles: '',
				token: false,
				username: '',
				loggedIn: false
			}
			commit(SET_STATE, user)
			localStorage.setItem('user', '')
			//window.location.href = "/";
		}
		response = e.response.data
	}
	_cleanUp(commit, response, response.status)
}
function _handleLogout(data, commit, options, getters) {
	const router = options.router
	let user = {}
	localStorage.removeItem('user');
	localStorage.setItem('unauthFlag', false)
	window.dispatchEvent(new Event('storage'));
	commit(SET_STATE, user)
	commit(Const.SET_LAST_SELECT_TRADING_ACCOUNT, [])
	commit(SET_STATE_PERSIST_LOCAL)
	if ('msg' in data && 'info' in data) {
		_cleanUp(commit, data.msg, data.info)
	}
	if (options.forward === true) {
		window.location.href = "/";
	}
}
function _executeApi(apiLink, globalParams, localParams, getToken, commit, callback) {
	try {
		let response_array = [];
		if (localParams.step == '5') { globalParams = globalParams.form }
		else if(localParams.type == 'form'){ globalParams = globalParams.form }
		else if(localParams.module == 'ticket-reply'){ globalParams = globalParams.form }
		if (getToken == '') { getToken = '' }
		localParams.parameter.pageLoader = true
		RxFactory.post(Enpoints.BASE_URL + apiLink, globalParams, getToken)
			.map(response => response.data)
			.subscribe(data => {
				localParams.parameter.pageLoader = false
				localStorage.setItem('unauthFlag', '')
				if ('info' in data) {
					if (data.info === 'OK') {
						response_array.res_data = data.data
						callback(false, response_array)
					} else {
						if (data.msg.code == 'BACk_MSG') {
							response_array.res_data = 'BME' + data.msg.msg
						} else if (data.msg.code == 'FILE_UPLOAD') {
							response_array.res_data = data.msg.msg
						} else {
							response_array.res_data = data.msg.code
						}

						response_array.res_msg = data.msg.msg
						callback(true, response_array)
					}
				}
			},
				e => {_handleErrorResponse(e, commit); })
	} catch (ex) { _handleErrorResponse(ex, commit) }
}
function _messageDisplayFunction(getParameter, getMessage, msgType) {
	getParameter.response_msg = getMessage
	getParameter.msg_type = msgType
}




// WEBPACK FOOTER //
// ./src/store/actions.js